import React from "react";
import { formatCurrencyTotals, formatMoney } from "../../lib/money";

const LABELS = {
  onlyfans_vip: "OnlyFans VIP",
  onlyfans_free: "OnlyFans Free",
  justforfans: "JustForFans",
  faphouse: "FapHouse",
  rawfuckclub: "RawFuckClub",
  theblowers: "TheBlowers",
  live_show: "Live shows",
};

// Renders `summary.combined` from GET /api/revenue/summary: one total per
// currency (never summed across currencies) plus every per-platform figure
// with its source and period.
export default function CombinedEarnings({ combined, compact = false }) {
  const figures = combined?.figures || [];
  if (!figures.length) {
    return <p className="text-sm text-zinc-500" data-testid="combined-earnings-empty">No earnings reported yet.</p>;
  }
  return (
    <div data-testid="combined-earnings">
      <div className="text-2xl font-bold text-white" data-testid="combined-earnings-totals">
        {formatCurrencyTotals(combined.by_currency)}
      </div>
      <p className="mt-1 text-[11px] text-zinc-500">{combined.note}</p>
      {!compact && (
        <ul className="mt-3 divide-y divide-zinc-900 text-sm">
          {figures.map((f) => (
            <li key={`${f.platform}:${f.account_id || ""}:${f.currency}:${f.source}`} className="flex justify-between gap-3 py-2" data-testid="combined-earnings-figure">
              <span className="min-w-0 text-zinc-300">
                {LABELS[f.platform] || f.platform}
                <span className="block text-[11px] text-zinc-500">
                  {f.source} · {f.period}{f.basis && f.basis !== "as recorded" ? ` · ${f.basis}` : ""}
                  {f.currency_assumed ? " · currency assumed USD" : ""}
                </span>
              </span>
              <span className="shrink-0 font-mono text-white">{formatMoney(f.amount, f.currency)}</span>
            </li>
          ))}
        </ul>
      )}
      {!compact && combined.excluded_ledger?.length > 0 && (
        <p className="mt-2 text-[11px] text-zinc-500" data-testid="combined-earnings-excluded">
          Not added again (already inside a platform figure):{" "}
          {combined.excluded_ledger.map((e) => `${LABELS[e.platform] || e.platform} ${formatMoney(e.amount, e.currency)}`).join(", ")}
        </p>
      )}
    </div>
  );
}
